<template>
  <div class="upload-container">
    <div class="upload-btn mx-auto">{{ $t("add_image") }}</div>
    <div v-if="!mobile" class="upload-drag mt-3">{{ $t("drag_image_to_upload") }}</div>
    <div class="upload-limit mt-3">{{ $t("img_limit_size") }}</div>
  </div>
</template>

<script>
export default {
  methods: {
    inputHandler(e) {
      this.fileHandler(e.target.files[0]);
    }
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.xs;
    }
  }
};
</script>

<style lang="scss" scoped>
.upload-container {
  background: #ffffff;
  width: 400px;
  border: 2px solid #bdbdbd;
  box-sizing: border-box;
  border-radius: 16px;
  text-align: center;
  padding: 20px;

  @media screen and (max-width: 960px) {
    width: 200px;
  }
}

.upload-btn {
  background: #ffa000;
  width: 150px;
  padding: 10px;
  border-radius: 3px;
  color: white;
  font-family: Roboto;
  font-weight: bold;
  font-size: 20px;
}

.upload-drag {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;

  @media screen and (max-width: 960px) {
    font-size: 14px;
  }
}

.upload-limit {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #424242;

  @media screen and (max-width: 960px) {
    font-size: 12px;
  }
}
</style>
